export default __webpack_public_path__ + "static/media/11.76d48f10.png";